export enum DeliveryRegisterState {
  EXPECTED_DATE,
  MULTIPLE_WITH_DANFE,
  MULTIPLE_WITHOUT_DANFE,
  MULTIPLE_WITH_NOTFIS,
  MULTIPLE_WITH_CTE,
  MULTIPLE_WITH_CTE_READ_NF,
  ORDER_NUMBER,
  ISSUE_DATE,
}
